import React from "react";
import { Input } from "@nextui-org/react";

const FormInput = ({ type = "text", label, value, onChange, ...props }) => {
  return (
    <div className="h-[80px] w-full">
      <Input
        isRequired
        type={type}
        label={label}
        radius="sm"
        variant="bordered"
        value={value}
        onValueChange={onChange}
        classNames={{
          input: ["text-white"],
          inputWrapper: ["border-default-400 data-[hover=true]:border-default-500"],
        }}
        // allows any additional props to be passed in and override defaults
        {...props}
      />
    </div>
  );
};

export default FormInput;
